/* eslint-disable no-loop-func */
import React from 'react';
import { components } from 'react-select';
import { Flex } from '@chakra-ui/react';
import { ChevronRight } from '@kula-ai/icons-core';
import { KText } from '@/ui-library/components';
import { DepartmentTreePopover } from './DepartmentTreePopover';

const getNodePath = (option: any, allOptions: any[]) => {
  const path = [];
  let current = option;

  path.unshift(current);

  while (current?.parent_id) {
    const parent = allOptions.find((item) => item.id === current.parent_id);
    if (parent) {
      path.unshift(parent);
      current = parent;
    } else {
      break;
    }
  }

  return path;
};

export const DepartmentSingleValue = (props: any) => {
  const { data, selectProps, labelKey = 'name' } = props;
  const { options } = selectProps;

  const nodePath = getNodePath(data, options);

  const displayPath =
    nodePath.length <= 3
      ? nodePath
      : [nodePath[0], { id: 'ellipsis', name: '...' }, ...nodePath.slice(-2)];

  return (
    <components.SingleValue {...props}>
      <Flex alignItems="center" gap="1">
        {displayPath.map((item, index) => (
          <React.Fragment key={item.id}>
            {index > 0 && <ChevronRight color="secondary-700" size={20} />}
            {item.id === 'ellipsis' ? (
              <DepartmentTreePopover department={data} allDepartments={options}>
                <KText
                  color="secondary-700"
                  fontSize="sm"
                  fontWeight="medium"
                  cursor="pointer"
                >
                  {item[labelKey]}
                </KText>
              </DepartmentTreePopover>
            ) : (
              <KText
                color={
                  index === 0
                    ? 'secondary-900'
                    : index === displayPath.length - 1
                    ? 'secondary-700'
                    : 'secondary-700'
                }
                fontSize="sm"
              >
                {item.name}
              </KText>
            )}
          </React.Fragment>
        ))}
      </Flex>
    </components.SingleValue>
  );
};

// for handling multi-select values
export const DepartmentMultiValue = (props: any) => {
  const { data, selectProps, labelKey = 'name' } = props;
  const { options } = selectProps;
  const nodePath = getNodePath(data, options);

  return (
    <components.MultiValue {...props}>
      <DepartmentTreePopover department={data} allDepartments={options}>
        <KText
          color="secondary-700"
          fontSize="sm"
          title={nodePath.map((item) => item.name).join(' > ')}
        >
          {data[labelKey]}
        </KText>
      </DepartmentTreePopover>
    </components.MultiValue>
  );
};
